import { render, staticRenderFns } from "./ManagementReportCard.vue?vue&type=template&id=ca05b192&"
import script from "./ManagementReportCard.vue?vue&type=script&lang=ts&"
export * from "./ManagementReportCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports